import {Numbers} from "./Numbers";

export const CostsUtils = {

	mixins: [Numbers],

	methods: {

		prepareExportData (module, manyModules, isProject, resourceId) {
			let costsCalculatedTableRef = isProject ? this.$refs['costsCalculatedTable-' + module] : this.$refs['costsCalculatedTable-' + module][0];
			let costsSummaryTableRef = isProject ? this.$refs['costsSummaryTable-' + module] : this.$refs['costsSummaryTable-' + module][0];
			return {
				module: module,
				manyModules: manyModules,
				administrativeCosts: this.getExportAdministrativeCosts(costsCalculatedTableRef),
				administrativeSummary: this.getAdministrativeSummaryCosts(costsCalculatedTableRef),
				actionCosts: this.getExportActionCosts(costsCalculatedTableRef),
				actionSummary: this.getActionSummaryCosts(costsCalculatedTableRef),
				wholeSummary: this.getWholeSummaryCosts(costsCalculatedTableRef),
				financeSources: this.getFinanceSources(costsSummaryTableRef),
				resourceId: resourceId
			};
		},

		getExportAdministrativeCosts (ref) {
			let costs = [];
			for (let cost of ref.normalizedAdministrative) {
				costs.push(this.createCostItem(cost));
			}
			return costs;
		},

		createCostItem (cost) {
			return {
				serialNumber: cost.serialNumber.toString(),
				name: cost.name,
				unitsCount: cost.unitsCount,
				pricePerUnit: this.formatMoney(cost.pricePerUnit),
				measureType: cost.measureType,
				totalPrice: this.formatMoney(cost.totalPrice),
				fromDonation: this.formatMoney(cost.fromDotation),
				fromOther: this.formatMoney(cost.fromOther),
				fromOwnHuman: this.formatMoney(cost.fromOwnHuman),
				fromOwnFinancial: this.formatMoney(cost.fromOwnFinancial)
			};
		},

		getAdministrativeSummaryCosts (ref) {
			return {
				totalPrice: this.formatMoney(ref.administrativeTotalPrice()),
				fromDonation: this.formatMoney(ref.administrativeFromDotation()),
				fromOther: this.formatMoney(ref.administrativeFromOther()),
				fromOwnHuman: this.formatMoney(ref.administrativeFromOwnHuman()),
				fromOwnFinancial: this.formatMoney(ref.administrativeFromOwnFinancial())
			};
		},

		createCostsForAction (action) {
			let costs = [];
			for (let cost of action.costs) {
				let item = this.createCostItem(cost);
				item.serialNumber = action.serialNumber + "." + item.serialNumber;
				costs.push(item);
			}
			return costs;
		},

		createActionItem (action, ref) {
			return {
				serialNumber: action.serialNumber.toString(),
				name: action.name,
				totalPrice: this.formatMoney(ref.actionTotalPrice(action)),
				fromDonation: this.formatMoney(ref.actionFromDotation(action)),
				fromOther: this.formatMoney(ref.actionFromOther(action)),
				fromOwnHuman: this.formatMoney(ref.actionFromOwnHuman(action)),
				fromOwnFinancial: this.formatMoney(ref.actionFromOwnFinancial(action)),
				costs: this.createCostsForAction(action)
			};
		},

		getExportActionCosts (ref) {
			let actions = [];
			for (let action of ref.normalizedCosts) {
				actions.push(this.createActionItem(action, ref));
			}
			return actions;
		},

		getActionSummaryCosts (ref) {
			return {
				totalPrice: this.formatMoney(ref.actionsTotalPrice()),
				fromDonation: this.formatMoney(ref.actionsFromDotation()),
				fromOther: this.formatMoney(ref.actionsFromOther()),
				fromOwnHuman: this.formatMoney(ref.actionsFromOwnHuman()),
				fromOwnFinancial: this.formatMoney(ref.actionsFromOwnFinancial())
			};
		},

		getWholeSummaryCosts (ref) {
			return {
				totalPrice: this.formatMoney(ref.administrativeTotalPrice() + ref.actionsTotalPrice()),
				fromDonation: this.formatMoney(ref.administrativeFromDotation() + ref.actionsFromDotation()),
				fromOther: this.formatMoney(ref.administrativeFromOther() + ref.actionsFromOther()),
				fromOwnHuman: this.formatMoney(ref.administrativeFromOwnHuman() + ref.actionsFromOwnHuman()),
				fromOwnFinancial: this.formatMoney(ref.administrativeFromOwnFinancial() + ref.actionsFromOwnFinancial())
			};
		},

		getFinanceSources (ref) {
			let sources = [];
			sources.push(this.formatMoney(ref.costsSummary.dotation));
			sources.push(this.formatMoney(ref.financialContribution));
			sources.push(this.formatMoney(ref.costsSummary.ownFinancialContribution));
			sources.push(this.formatMoney(ref.costsSummary.moneyFromRecipients));
			sources.push(this.formatMoney(ref.costsSummary.otherPublicSource));
			sources.push(this.formatMoney(ref.costsSummary.other));
			sources.push(this.formatMoney(ref.ownContribution));
			sources.push(this.formatMoney(ref.costsSummary.ownHumanContribution));
			sources.push(this.formatMoney(ref.costsSummary.ownContributionInKind));
			sources.push(this.formatMoney(ref.totalCosts));
			sources.push(ref.totalContributionToDotationPercentage + " %");
			sources.push(ref.dotationToWholePercentage + " %");
			sources.push(ref.financialContributionToDotationPercentage + " %");
			sources.push(ref.ownContributionToDotationPercentage + " %");
			return sources;
		},

		prepareAgencyExportData (resourceId) {
			let agencyActionCostsRef = this.$refs.agencyActionCosts;
			return {
				currencyCode: agencyActionCostsRef.currencyCode,
				costs: this.getAgencyExportCosts(agencyActionCostsRef),
				paragraphs: this.getAgencyExportParagraphs(agencyActionCostsRef),
				total: this.getAgencyExportTotal(agencyActionCostsRef),
				resourceId: resourceId
			};
		},

		getAgencyExportCosts (ref) {
			let costs = [];
			for (let cost of ref.costs) {
				costs.push(this.createAgencyCostItem(cost, ref));
			}
			return costs;
		},

		createAgencyCostItem (cost, ref) {
			return {
				actionName: ref.actions.find(item => item.id === cost.actionId).action,
				expenseName: cost.expenseName,
				mszFundings: this.formatMoney(cost.mszFundings),
				paragraph: ref.paragraphs.find(item => item.id === cost.paragraphId).name,
				ownFundings: this.formatMoney(cost.ownFundings),
				totalFundings: this.formatMoney(Number.parseFloat(cost.ownFundings) + Number.parseFloat(cost.mszFundings))
			};
		},

		getAgencyExportParagraphs (ref) {
			let paragraphs = [];
			for (let paragraph of ref.paragraphs) {
				if (paragraph.totalMszFundingsForParagraph) {
					paragraphs.push(this.createAgencyParagraphItem(paragraph));
				}
			}
			return paragraphs;
		},

		createAgencyParagraphItem (paragraph) {
			return {
				name: paragraph.name,
				mszFundings: this.formatMoney(paragraph.totalMszFundingsForParagraph),
				ownFundings: this.formatMoney(paragraph.totalOwnFundingsForParagraph),
				totalFundings: this.formatMoney(paragraph.totalFundings)
			};
		},

		getAgencyExportTotal (ref) {
			return {
				name: "łącznie",
				mszFundings: this.formatMoney(ref.totalMszFundings),
				ownFundings: this.formatMoney(ref.totalOwnFundings),
				totalFundings: this.formatMoney(ref.totalFundings)
			};
		}
	}
};